<app-navbar></app-navbar>

<div class="contact-header">
  <h1>Hello. What do you need help with?</h1>

  <div class="contact-info mt-3">
    <a href="mailto:help@brandqrcodes.net">help@brandqrcodes.com</a>

    <div class="social-media mt-3">
      <a href="https://www.linkedin.com/company/brandqrcodes" target="_blank">
        <i class="bi bi-linkedin"></i>
      </a>
      <a href="https://www.facebook.com/brandqrcodes" target="_blank">
        <i class="bi bi-facebook"></i>
      </a>
      <a href="https://www.instagram.com/brandqrcodes" target="_blank">
        <i class="bi bi-instagram"></i>
      </a>
      <a href="https://twitter.com/brandqrcodes" target="_blank">
        <i class="bi bi-twitter"></i>
      </a>
      <!--
            <a href="https://www.youtube.com/channel/UCvg-tYS0v9jVpriCJe57oxw" target="_blank">
                <i class="bi bi-youtube"></i>
            </a> -->
    </div>
  </div>
</div>

<div class="support-wrapper">
  <div class="container">
    <div class="box-wrapper animated fadeIn">
      <div class="row g-4">
        <div class="col-lg-4 col-md-6">
          <div class="box">
            <div class="icon">
              <i class="bi bi-question-circle"></i>
            </div>
            <h4>FAQs</h4>
            <p>Find the answers to all the frequently asked questions <a routerLink="/faq">here</a></p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="box">
            <div class="icon">
              <i class="bi bi-signpost"></i>
            </div>
            <h4>How to get started</h4>
            <p>To get started for free, click <a routerLink="/auth/signup" target="_blank">here</a> and sign
              up to get access to analytics of your links and other premium features</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="box">
            <div class="icon">
              <i class="bi bi-people"></i>
            </div>
            <h4>Manage your team</h4>
            <p>Create teams, and add team members for easy collaboration.
              Check out how to do this <a routerLink="/faq">here</a>.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="box">
            <div class="icon">
              <i class="bi bi-gear"></i>
            </div>
            <h4>Developer tools</h4>
            <p>Click <a routerLink="/api-documentation">here</a> to integrate our API, if you are a developer looking to
              integrate our service into your web application</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="box">
            <div class="icon">
              <i class="bi bi-chat-quote"></i>
            </div>
            <h4>Testimonials</h4>
            <p>Read how businesses, creators and individuals are using brandqrcodes to stay on top of their
              digital content
              management.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="box">
            <div class="icon">
              <i class="bi bi-chat-square-text"></i>
            </div>
            <h4>Our blog</h4>
            <p>This is our knowledge base, where we share tips on how to optimise your links to perform
              better, and
              general marketing and business tips. <a routerLink="/blog">Check it out</a>.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 text-center my-5">
          <br><br>
          <h3>Any questions or remarks?</h3>
          <p>Just write us a message</p>
          <p>
            <a class="btn btn-secondary-light" routerLink="/contact-us">
              <i class="bi bi-envelope me-2"></i>
              Contact us</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>